import angular from 'angular';
import uiRouter from 'angular-ui-router';
import spendingsComponent from './spendings.component';
import dataTable from 'angular-material-data-table';

let spendingsModule = angular.module('spendings', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('spendings', {
        url: '/spendings',
        component: 'spendings',
        parent: 'main',
        data: {
            permissions: {
                only: ['OPERATOR'],
                redirectTo: 'home'
            }
        },
        resolve: {
        }
    });
})
.component('spendings', spendingsComponent)
.name;

export default spendingsModule;
